import React, { ReactElement } from "react"
import Select, { SingleValue } from "react-select"
import { Checkbox, FormLabel, TextInput } from "@wfp/ui"
import { IGroupForm } from "interfaces/xlsForm"
import { filterOption } from "utils/helpers"
import { useGetGroupListQuery } from "services/household/xlsFormSchemas"
import CustomOption from "components/Shared/Common/CustomOption"
import { OptionGroup } from "interfaces/mappingInterfaces"

type Props = {
  xlsFormId: number
  form: IGroupForm
  setForm: React.Dispatch<React.SetStateAction<IGroupForm>>
}

const GroupForm = ({ xlsFormId, form, setForm }: Props): ReactElement => {
  const { data: groupList, isLoading: loadingGroups } = useGetGroupListQuery(xlsFormId)

  return (
    <div className="flex flex-col gap-4">
      <Checkbox
        wrapperClassName="!mb-1"
        labelText="Repeat group"
        id="repeat"
        onChange={e => setForm(prev => ({ ...prev, isRepeat: e.target.checked }))}
        value="isRepeat"
      />
      <TextInput
        labelText="Name"
        name="name"
        formItemClassName="text-required"
        className="custom-text-field"
        onChange={e => setForm(prev => ({ ...prev, name: e.target.value }))}
      />
      <TextInput
        labelText="Label"
        name="label"
        className="custom-text-field"
        formItemClassName="text-required"
        onChange={e => setForm(prev => ({ ...prev, label: e.target.value }))}
      />

      <div>
        <FormLabel htmlFor="group">Parent group</FormLabel>
        <Select
          inputId="group"
          placeholder="Select group"
          className="select-wrapper"
          classNamePrefix="select"
          isLoading={loadingGroups}
          options={groupList || []}
          getOptionLabel={option => option.label}
          getOptionValue={option => option.value}
          components={{ Option: CustomOption }}
          value={groupList?.find(item => Number(item.value) === form.groupId)}
          onChange={item => {
            setForm(prev => ({ ...prev, groupId: Number((item as SingleValue<OptionGroup>)?.value) }))
          }}
          isClearable
          isSearchable
          filterOption={filterOption}
          menuPlacement="auto"
        />
      </div>
    </div>
  )
}

export default GroupForm
